const cleanName = (value) => String(value || "").trim();

export const getHatTipDisplayName = (reaction = {}) =>
  cleanName(
    reaction.displayName ||
      reaction.authorName ||
      reaction.name ||
      reaction.publicName ||
      reaction.userName
  );

export const getHatTipSummary = (reactions = [], currentUserId = "") => {
  const seen = new Set();
  const normalized = reactions
    .filter((reaction) => reaction?.type === "helpful")
    .filter((reaction) => {
      const key = reaction.id || reaction.userId;
      if (!key) return true;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });

  const count = normalized.length;
  if (count === 0) return "";

  const currentUserReacted = Boolean(
    currentUserId &&
      normalized.some(
        (reaction) => reaction.id === currentUserId || reaction.userId === currentUserId
      )
  );
  const others = normalized.filter(
    (reaction) => !(currentUserId && (reaction.id === currentUserId || reaction.userId === currentUserId))
  );
  const firstOtherName = getHatTipDisplayName(others[0]) || "A neighbor";

  if (count === 1) {
    return currentUserReacted ? "You tipped your hat" : `${firstOtherName} tipped their hat`;
  }

  if (count === 2) {
    if (currentUserReacted) {
      return `You and ${firstOtherName} tipped your hats`;
    }

    const secondOtherName = getHatTipDisplayName(others[1]) || "another neighbor";
    return `${firstOtherName} and ${secondOtherName} tipped their hats`;
  }

  if (currentUserReacted) {
    return `You and ${count - 1} others tipped their hats`;
  }

  return `${firstOtherName} and ${count - 1} others tipped their hats`;
};

export const getHatTipAvatarReactions = (reactions = [], currentUserId = "", limit = 3) => {
  const seen = new Set();

  return reactions
    .filter((reaction) => reaction?.type === "helpful")
    .filter((reaction) => {
      const key = reaction.id || reaction.userId;
      if (!key) return true;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .sort((a, b) => {
      const aIsCurrent = currentUserId && (a.id === currentUserId || a.userId === currentUserId);
      const bIsCurrent = currentUserId && (b.id === currentUserId || b.userId === currentUserId);
      return Number(bIsCurrent) - Number(aIsCurrent);
    })
    .slice(0, limit);
};
